import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { SpeakerService } from '../../core/services/speaker.service';
import { Speaker } from '../../core/models/speaker';
import { ProfileForThisEvent } from '../../core/models/profileForThisEvent';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { UtilityService } from '../../core/services/utility.service';

import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { MultiUtility } from '../../shared/multi-utility';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-speakers-form',
  templateUrl: './speakers-form.component.html',
  styleUrls: ['./speakers-form.component.css'],
  providers: [ExtraService, UtilityService, SpeakerService]
})
export class SpeakersFormComponent implements OnInit {
  name: string = "pankaj";
  email: string = 'pt06544@gmail.com';
  message: string = '';
  profileImageUri: string = 'assets/img/default-user.png';
  eventID: string;
  spikerid: string = null;
  keyId: string;
  speakerId: string = null;
  fileName: string;
  speaker = new Speaker();
  profileForThisEvent1 = new ProfileForThisEvent();

  speakerList: Array<Speaker> = new Array();

  dropzoneActive: boolean = false;
  bannerImageFile: File = null;

  constructor(private extraService: ExtraService, private route: ActivatedRoute, private confirmationService: ConfirmationService,
    private speakerService: SpeakerService, private utilityService: UtilityService, private router: Router, private multiUtility: MultiUtility, ) {

  }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      //this.message = params['confirmMessage'];
      if (params['eventId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.setSpeakerList(params['eventId']);
      }
    });
  }

  setSpeakerList(id) {
    var x = this.speakerService.getSpeakerProfile(id);
    x.snapshotChanges().subscribe(list => {
      //this.contactIdList = new Array();
      this.speakerList = new Array();
      list.forEach(element => {
        var y = element.payload.toJSON();
        y["$key"] = element.key;
        this.speakerList.push(y as Speaker);
        //console.log(this.speakerList)
      });
      console.log(this.speakerList)
    });
  }

  confirmDelete(event: Speaker) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete Speaker: ' + event.profile.name + '?',
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  deleteEvent(event) {
    this.speakerService.deleteSpeakerID(event, this.eventID).then(res => {
      this.message = "Speaker deleted Successfully";
    }).catch(error => {
      console.log(error.message);
    });
    setTimeout(() => {
      this.message = null;
      this.setSpeakerList(this.eventID);
    }, 1000);

  }





  getSpeakerById(eventId: string, speakerId: string) {
    this.speakerService.getSpeakerById(eventId, speakerId).subscribe(event => {
      if (event) {
        this.speaker = event;
        console.log("huuh  " + this.speaker);

        this.speaker = new Speaker();
        this.speaker.name = event.name;
        this.speaker.position = event.position;
        this.speaker.email = event.email === undefined ? null : event.email;
        this.speaker.type = event.type === undefined ? null : event.type;
        this.speaker.fileCMId = event.fileCMId === undefined ? null : event.fileCMId;
        this.speaker.profileImageUri = event.profileImageUri === undefined ? null : event.profileImageUri;
        this.speaker.isEmailVisible = event.isEmailVisible === undefined ? null : event.isEmailVisible;
        this.speaker.isPhoneNumberVisible = event.isPhoneNumberVisible === undefined ? null : event.isPhoneNumberVisible;
        this.speaker.isProfileImageVisible = event.isProfileImageVisible === undefined ? null : event.isProfileImageVisible;
        this.speaker.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;
        this.speaker.organization = event.organization === undefined ? null : event.organization;
        this.speaker.designation = event.designation === undefined ? null : event.designation;

        this.speaker.aboutList = event.aboutList === undefined ? [] : event.aboutList;


        // if (this.speaker.aboutList) {
        // 	this.speaker.aboutList.forEach(element => {
        // 		this.addComponent(element, this.dropDown, this.eventId);
        // 	});
        // } else {
        // 	this.speaker.aboutList = [];
        // }
        // this.initThings();

        // this.getCategoryItemName(eventId, Constants.CATEGORY_SPEAKERS, this.speaker.type).subscribe(event => {
        // 	if (event) {
        // 		console.log('getCategoryItemName	:	' + event);
        // 		this.speakerTypeText = event;
        // 	}
        // });
      }
    });
  }

  dropHandler(fileList) {
    console.log('File(s) dropped', fileList);
    this.uploadImage(fileList, '');
  }

  dropzoneState($event: boolean) {
    this.dropzoneActive = $event;
  }

  uploadImage(event, source) {
    console.log('Source Logo :: ', source, event);
    this.bannerImageFile = event.files[0];
    this.multiUtility.uploadImageToStorage(this.bannerImageFile, firebase, this.speaker, this.eventID, Constants.CONTENT_M_TYPE_SPEAKERS, Constants.IMAGE_UPLOAD_TYPE_BANNER);
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/speakers-form/speakers-form.component.ts